import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 75rem;

    @media (max-width: 480px) {
        gap: 1rem;
    }
`;

export const Columns = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
    gap: 2rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
      gap: 0.5rem;
  }
`;

export const TwoColumnGrid = styled.div`
    width: 100%;
    display: grid;
    grid: auto-flow dense / 1.25fr .75fr;
    gap: 2rem;
    
    @media (max-width: 768px) {
        grid: auto-flow dense / 1fr;
    }
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 75rem;
  padding: 1rem 2rem 1rem 2rem;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 480px) {
    flex-direction: column;
      align-items: normal;
      gap: 0.5rem;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.25rem;
  padding: 0.5rem;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const LogoutButton = styled.button`
  width: 20rem;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  color: #fff;
  background-color: #1e1e1e;
  border: none;
  border-radius: 0;
  cursor: pointer;

  &:hover {
    background-color: #282828;
  }
`;

export const NavContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 75rem; // 1200px
  justify-content: space-between;
  align-items: center;
`;

export const NavLeft = styled.div`
  display: flex;
  gap: 1rem;
`;

export const NavRight = styled.div`
  display: flex;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem;

  @media (max-width: 480px) {
    width: 100%;
  }
`;
